import { render, staticRenderFns } from "./PropEditDialog.vue?vue&type=template&id=92b9ef8a&scoped=true&"
import script from "./PropEditDialog.vue?vue&type=script&lang=js&"
export * from "./PropEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b9ef8a",
  null
  
)

export default component.exports